// extracted by mini-css-extract-plugin
export default {"container":"SetPasswordUser_container__vFY0G","boxModal":"SetPasswordUser_boxModal__SNxFR","boxBtn":"SetPasswordUser_boxBtn__1cg2p"};